import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
import { EntityExtensionClass, IEntity } from './entities/entity';

function searchEntitiesByNameQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function searchEntitiesByNameInput(queryResultSettings: IQueryResultSettings, name: string): IDataServiceRequest {
    const query = searchEntitiesByNameQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SearchEntitiesByName',
        false,
        EntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'IEntity' },
        { name }
    );
}

export function searchEntitiesByNameAsync(context: IContext, name: string): AsyncResult<IEntity[]> {
    return callActionOrExecute<IEntity[]>(searchEntitiesByNameInput(context.queryResultSettings || {}, name), context.callerContext);
}
